import { createSlice } from '@reduxjs/toolkit';

const initialState = { token: null, machineID: null, user: null };

export const auth = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    _init: (state, action) => {
      return { ...state, ...action?.payload };
    },
    setUser: (state, action) => {
      state.user = action?.payload ?? null;
    },
    _exit: () => initialState,
  },
});

export const { _init, _exit, setUser } = auth.actions;

export default auth.reducer;
